import React,{useEffect} from "react";
import { withRouter } from 'react-router-dom';
import ErrorPage from './ErrorPage';

const NotFound = ({ history }) => {
    useEffect(() => {
        history.replace('/not-found', { status: 404 });
      }, []);
    return (
        <div>
            <ErrorPage mainText="Página no encontrada"></ErrorPage>
        </div>
    );
};

export default withRouter(NotFound);